import { UserRoles } from '../enums/userRoles.enum';

export const landingRouteFor = (roles: string[] = [], employmentStatus?: string): string => {
  if (employmentStatus === 'Terminated') {
    return '/access-unavailable';
  }

  if (roles.includes(UserRoles.admin)) {
    return '/administration';
  }

  if (roles.includes(UserRoles.sales)) {
    return '/sales';
  }

  if (roles.includes(UserRoles.employee)) {
    return '/account-settings';
  }

  return '/access-unavailable';
};
